import { render, staticRenderFns } from "./PricingPlan.vue?vue&type=template&id=6d147108&scoped=true&"
import script from "./PricingPlan.vue?vue&type=script&lang=js&"
export * from "./PricingPlan.vue?vue&type=script&lang=js&"
import style0 from "./PricingPlan.vue?vue&type=style&index=0&id=6d147108&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d147108",
  null
  
)

export default component.exports